<template>
  <div id="app-price-widget">
    <div class="widget-wrapper">
      <div class="widget">
        <div>
          <div class="widget-label" style="padding-bottom: 0;">
            Phone number
          </div>
          <input class="widget-input"
                 v-model="number"
                 type="text"
                 placeholder="+44-742-000-00-00">
        </div>
        <div>
          <div class="widget-label">Crypto currency</div>
          <button-list :list="cryptoOptions" @select="selectCrypto"/>
          <div class="widget-label">Fiat currency</div>
          <button-list :list="fiatOptions" @select="selectFiat"/>
        </div>

        <button @click="click"
                :class="[ 'widget-button', { blocked: waiting, large: true }]">
        {{ waiting ? "Sending..." : "Send price in SMS" }}
        </button>
      </div>
      <div class="error-message">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ButtonList from './BUttonList.vue'

const params = {
  url: 'https://saas.sparkl.com/svc_rest/admin@sparkl.com/Scratch/CryptoCurrencySMS/Rest?mode=transitive',
  delay: 10000
}

var pushToSparkl = function(ticker, mobile, callback) {
    return axios({
      url: params.url,
      method: 'post',
      data: JSON.stringify({
        call: 'Mix/Solicit',
        data: {
          ticker: ticker,
          mobile: mobile
        }
      }),
      headers: {
        'Accept': 'application/json'
      }
    })
};

export default {
  name: 'app',
  components: {
    ButtonList
  },
  data () {
    var fiat = ['USD', 'EUR', 'GBP', 'RUB', 'CHF', 'NZD']
    var crypto = ['BTC', 'ETC', 'ETH', 'XRP', 'DGB', 'LTC']

    return {
      waiting: false,
      number: '',
      fiat: fiat[0],
      crypto: crypto[0],
      fiatOptions: fiat,
      cryptoOptions: crypto
    }
  },
  methods: {
    click () {
      this.waiting = true

      let pair = (this.crypto + ':' + this.fiat).toLowerCase()
      let number = this.number.replace(/[-\s]+/gi, '')

      pushToSparkl(pair, number)
        .then(response => {
          this.waiting = false
        })
        .catch(error => {
          this.waiting = false
        })
    },

    selectFiat (event) {
      this.fiat = event.button
    },

    selectCrypto (event) {
      this.crypto = event.button
    }
  }
}
</script>

<style lang="scss">

$text-color: #fff;
$background-color: #3B99FC;
$shadow-color: rgba($background-color, 0.25);

#app-price-widget {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
  margin: 10px;

  .widget-wrapper {
    padding-bottom: 20px;
  }

  .widget {
    display: relative;
    max-width: 400px;
    min-height: 100px;

    margin: 10px auto;

    background: #fff;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0px 12px 25px 0px rgba(#1D242E, 0.15);
  }

  .error-message {
    text-align: center;
  }

  .widget-input {
    height: 44px;
    background: transparent;
    box-sizing: border-box;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 0;
    padding-bottom: 0;
    border: 0;
    margin: 0;
    border-bottom: 1px solid #dbe2e8;
    font-size: 14px;
    color: #2e3d49;
    width: 100%;
    box-shadow: none;
    margin-top: 0;
    padding-top: 0;
    outline: none;

    transition: border-bottom-color 300ms;

    &:focus {
      background: transparent;
      border-bottom-color: $background-color;
    }
  }

  .widget-label {
    display: block;
    text-align: left;
    padding: 10px;
  //  padding-bottom: 0;
    padding-top: 25px;
    padding-bottom: 10px;

    opacity: 0.7;

    font-weight: 600;
    font-size: 13px;
  }

  .widget-button {
   border: 0;
   padding: 10px 30px;
   margin-top: 20px;
   margin-bottom: 2px;
   background: $background-color;
   color: $text-color;
   cursor: pointer;
   outline: none;
   border-radius: 8px;
   box-shadow: 0 5px 10px 0 rgba($background-color, 0.4);
   transition: all 300ms;
   font-weight: 600;
   font-size: 12px;

    &.large {
      width: 100%;

      &:active {
        transform: translateY(2px);
        box-shadow: 0 3px 5px 0 rgba($background-color, 0.6);
      }

      &.blocked {
        transform: translateY(2px);
        box-shadow: 0 3px 5px 0 rgba($background-color, 0.6);
        opacity: 0.7;
        pointer-events: none;
      }
    }
  }

  .widget-button-list {
    display: flex;
    flex-direction: row;

    // margin-top: 10px;
    box-shadow: 0 5px 10px 0 rgba(#555, 0.2);
    border-radius: 8px;

    .widget-button {
      box-sizing: border-box;
      border-radius: 0;
      margin: 0;
      padding-left: 0;
      padding-right: 0;

      &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      &:not(.selected) {
        color: #555;
      }

      background-color: #f3f3f3;

      &.selected {
        color: #3B99FC;
      }

      box-shadow: none;
    }
  }

  ::-webkit-input-placeholder {
    color: #aaa;
  }
  ::-moz-placeholder {
    color: #aaa;
  }
  :-ms-input-placeholder {
    color: #aaa;
  }
  :-moz-placeholder {
    color: #aaa;
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?7a56abb4